import { createFileRoute } from '@tanstack/react-router'
import { CasePage } from '@bloo-team/product-vantage'

/**
 * Composer shim (S5.0, docs/modularization.md §Route mounting): route
 * infrastructure stays in the app's tree; the V2 case page lives in
 * @bloo-team/product-vantage.
 */
function CaseRoute() {
  const { clusterId, scopeId, caseId } = Route.useParams()
  return <CasePage clusterId={clusterId} scopeId={scopeId} caseId={caseId} />
}

export const Route = createFileRoute('/$clusterId/$scopeId/vantage/cases_/$caseId')({
  component: CaseRoute,
})
